import { pipe } from 'pipe-and-compose';

import { UnknownObject } from '../../types';

interface EncryptQueryParams {
  (obj: UnknownObject): string;
}

const nodeEncrypter = (str: string) =>
  Buffer.from(str, 'ascii').toString('base64');

const browserEncrypter = (str: string) => window.btoa(str);

export const getEncrypterForEnv = (isNode: boolean) =>
  isNode ? nodeEncrypter : browserEncrypter;

const encryptQueryParams: EncryptQueryParams = pipe(
  JSON.stringify,
  getEncrypterForEnv(typeof window === 'undefined'),
  (encriptedObj) => `query=${encriptedObj}`,
);

export default encryptQueryParams;
